import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { GetAllAtributoProdutoResponse } from '../../responses/produto/get-all-atributo-produto.response';
import { GetAtributoProdutoResponse } from '../../responses/produto/get-atributo-produto.response';
import { ReturnStruct } from '../../structs/return.struct';
import { AtributoProdutoRequest } from '../../requests/produto/atributo-produto.request';
import { GetCampoEquivalenteLookupResponse } from '../../structs/produto/campo-equivalente-lookup.struct';

@Injectable({
    providedIn: 'root',
})
export class AtributoProdutoService extends CommonService {
    constructor(
        private httpClient: HttpClient
    ) {
        super();
    }

    private readonly apiUrl = `${environment.urlApiProduto}atributos`;
    private readonly lookupUrl = `${environment.urlApiProduto}lookup/campoequivalenteatributo`;

    public getAll(nome: string = '', pagina: number = 1, tamanhoPagina: number = 20): Observable<GetAllAtributoProdutoResponse> {
        let params = new HttpParams()
            .set('pagina', pagina.toString())
            .set('tamanhoPagina', tamanhoPagina.toString());

        if (nome) {
            params = params.set('nome', nome);
        }

        return this.httpClient
            .get<GetAllAtributoProdutoResponse>(this.apiUrl, { params, ...this.addHeaderToken() })
            .pipe(catchError(this.handleError));
    }

    public getById(id: number): Observable<GetAtributoProdutoResponse> {
        const url = `${this.apiUrl}/${id}`;

        return this.httpClient
            .get<GetAtributoProdutoResponse>(url, { ...this.addHeaderToken() })
            .pipe(catchError(this.handleError));
    }

    public create(request: AtributoProdutoRequest): Observable<ReturnStruct> {
        return this.httpClient
            .post<ReturnStruct>(this.apiUrl, request, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public update(id: number, request: AtributoProdutoRequest): Observable<ReturnStruct> {
        const url = `${this.apiUrl}/${id}`;

        return this.httpClient
            .put<ReturnStruct>(url, request, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public delete(id: number): Observable<ReturnStruct> {
        const url = `${this.apiUrl}/${id}`;

        return this.httpClient
            .delete<ReturnStruct>(url, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public deleteBulk(idsAtributo: number[]): Observable<ReturnStruct> {
        const url = `${this.apiUrl}/bulk-delete`;

        return this.httpClient
            .post<ReturnStruct>(url, { idsAtributo }, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public getLookupCampoEquivalente(): Observable<GetCampoEquivalenteLookupResponse> {
        return this.httpClient
            .get<GetCampoEquivalenteLookupResponse>(this.lookupUrl, { ...this.addHeaderToken() })
            .pipe(catchError(this.handleError));
    }
}
